/*   */
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { toAbsoluteUrl } from "../../../_metronic";

import { updateProfilePicFunc } from "../../store/ducks/auth.duck";
import Badge from "@mui/material/Badge";
import { FormattedMessage } from "react-intl";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import { withStyles } from "@mui/styles";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./loader.css";

import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import PerfectScrollbar from "react-perfect-scrollbar";
import IconButton from "@mui/material/IconButton";
import EmailIcon from "@mui/icons-material/Email";
import clsx from "clsx";
import { FiAlignCenter } from "react-icons/fi";
import { FiUsers } from "react-icons/fi";
import { FiLayout } from "react-icons/fi";
import { FiCodesandbox } from "react-icons/fi";
import { FiUser } from "react-icons/fi";
import { FiLayers } from "react-icons/fi";
import boopSfx from "../../../noti1.mp3";
import { AuthContext } from "../../../AuthContextProvider";

const styles = (theme) => ({
  list: {
    width: 375,
    height: "100%",
    padding: "30px 0px 40px 0px",

    [theme.breakpoints.down("xs")]: {
      width: "70vw",
    },
  },
  sideBarPadding: {
    paddingLeft: "30px !important",
    paddingRight: "30px !important",
  },
  fullList: {
    width: "auto",
  },
  staticCon: {
    minHeight: 100,
    [theme.breakpoints.down("xs")]: {
      minHeight: 50,
    },
  },
});

const audio = new Audio(boopSfx);

const UserProfile = ({ classes, logOutTrigger, usdBalance }) => {
  const { userContextApi, userWallet } = useContext(AuthContext);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userTutor, setUserTutor] = useState(false);
  const [userStudent, setUserStudent] = useState(false);
  const [activeHelpReq, setActiveHelpReq] = useState(0);
  const [sideToggle, setSideToggle] = useState(false);

  const checkUserStatus = async () => {
    if (userContextApi.userData) {
      const uid = userContextApi.userData.uid;
      //is user admin
      const isUserAdminStatus = await firebase
        .database()
        .ref("/admins/" + uid)
        .once("value")
        .then((snapshot) => (snapshot.val() ? true : false));
      const isUseTutor = await firebase
        .database()
        .ref("/KeyStore/" + uid + "/isTutor")
        .once("value")
        .then((snapshot) => (snapshot.val() ? snapshot.val() : false));
      const isUserStudent = await firebase
        .database()
        .ref("/KeyStore/" + uid + "/hireTutors")
        .once("value")
        .then((snapshot) => (snapshot.val() ? true : false));
      setIsAdmin(isUserAdminStatus);
      setUserStudent(isUserStudent);
      setUserTutor(isUseTutor);
      //getting active help requests
      if (isUseTutor) {
        firebase
          .database()
          .ref("/studentRequests")
          .on("value", (snap) => {
            if (snap.val()) {
              let objData = Object.values(snap.val()).filter(
                (obj) =>
                  !obj.isPrivate &&
                  obj.status !== "joined" &&
                  obj.studentID !== uid
              );
              setActiveHelpReq(objData.length);
            } else {
              setActiveHelpReq(0);
            }
          });
        firebase
          .database()
          .ref("/studentRequests")
          .on("child_added", (snap) => {
            togglePlay();
          });
      } else {
        setActiveHelpReq(0);
      }
    }
  };

  const togglePlay = () => {
    audio.play();
  };

  useEffect(() => {
    checkUserStatus();
  }, []);

  return (
    <div
      className="kt-header__topbar-item kt-header__topbar-item--user"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        padding: "0px 10px",
      }}
    >
      <div
        style={{ display: "flex", cursor: "pointer" }}
        onClick={() => setSideToggle(true)}
      >
        <div style={{ display: "flex" }}>
          <span className="flex justify-center items-center text-gray-500">
            <FormattedMessage id="TOPBAR.DROPDOWN1" defaultMessage="Hi," />
          </span>

          <span
            className="flex justify-center items-center font-medium text-sm text-gray-500 px-1"
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {userContextApi.userData?.displayName}
          </span>
        </div>

        <div style={{}}>
          {userContextApi.userData?.photoURL ? (
            <img
              className="w-10 rounded-md"
              alt="Pic"
              src={userContextApi.userData?.photoURL}
            />
          ) : (
            <span className="py-2 px-3 rounded-md bg-gray-100">
              {userContextApi.userData?.displayName &&
                userContextApi.userData?.displayName[0]}
            </span>
          )}
        </div>
      </div>
      <Drawer
        anchor="right"
        open={sideToggle}
        onClose={() => setSideToggle(false)}
      >
        <div
          style={{ height: "100%" }}
          tabIndex={0}
          role="button"
          onClick={() => setSideToggle(false)}
          onKeyDown={() => setSideToggle(false)}
        >
          <div className={classes.list} style={{ height: "100%" }}>
            <div
              style={{ display: "flex", alignItems: "center", height: "5%" }}
              className={classes.sideBarPadding}
            >
              <h5 className="font-medium h5">User Profile</h5>
              <button
                className="btn-success btn-sm btn-bold btn-font-md"
                style={{
                  marginLeft: "14px",
                  marginRight: "14px",
                  minWidth: "50px",
                  flexShrink: 0,
                }}
              >
                ${" "}
                {(userWallet.Balance &&
                  (parseFloat(usdBalance) * 100000000).toFixed(3)) ?? (
                    <span class="loader"></span>
                  )}
              </button>
              <IconButton
                aria-label="close"
                onClick={() => setSideToggle(false)}
                size="small"
                style={{
                  backgroundColor: "#f3f6f9",
                  marginLeft: "auto",
                  borderRadius: 5,
                  padding: 5,
                }}
              >
                <CloseIcon fontSize="small" style={{ color: "#b5b5c3" }} />
              </IconButton>
            </div>
            <PerfectScrollbar
              style={{
                maxHeight: "94%",
                height: "auto",
                marginTop: 10,
                paddingBottom: 20,
              }}
            >
              <div
                className={classes.sideBarPadding}
                style={{
                  display: "flex",
                  alignItems: "center",
                  minHeight: 80,
                  marginBottom: 25,
                }}
              >
                <div style={{ width: "35%", height: "100%", marginRight: 15 }}>
                  {(() => {
                    if (!userContextApi.userData?.photoURL) {
                      return (
                        <div
                          style={{
                            height: "auto",
                            width: "100%",
                            backgroundColor: "#f3f6f9",
                            color: "#0abb87",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: 14,
                            fontWeight: 600,
                            borderRadius: 10,
                          }}
                          className={classes.staticCon}
                        >
                          {userContextApi.userData?.displayName &&
                            userContextApi.userData.displayName[0]}
                        </div>
                      );
                    } else {
                      return (
                        <img
                          style={{
                            height: "auto",
                            width: "100%",
                            borderRadius: 10,
                          }}
                          src={userContextApi.userData?.photoURL}
                          alt="pic"
                        />
                      );
                    }
                  })()}
                </div>
                <div style={{ width: "65%", height: "100%" }}>
                  <Typography
                    variant="h5"
                    style={{
                      fontWeight: 500,
                      fontSize: 20,
                      color: "#3f4254",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {userContextApi.userData?.displayName}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{
                      fontSize: 14,
                      display: "flex",
                      alignItems: "center",
                      color: "#92929e",
                    }}
                  >
                    <EmailIcon
                      style={{
                        fontSize: 16,
                        marginRight: 5,
                      }}
                    />
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {userContextApi.userData.email}
                    </span>
                  </Typography>
                  <button
                    className="custom-signout-button mt-2 px-4"
                    onClick={logOutTrigger}
                  >
                    <FormattedMessage
                      id="TOPBAR.DROPDOWN.SIGNOUT"
                      defaultMessage="Sign Out"
                    />
                  </button>
                </div>
              </div>
              <div className={classes.sideBarPadding}>
                <Divider light />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: 15,
                  marginTop: 15,
                }}
              >
                <div className="kt-notification">
                  <Link
                    to="/profile"
                    className={clsx(
                      "kt-notification__item",
                      classes.sideBarPadding
                    )}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div
                      className="kt-notification__item-icon"
                      style={{
                        backgroundColor: "#f3f6f9",
                        borderRadius: 5,
                        padding: "6px 8px",
                        marginRight: 10,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FiUser color="#5867dd" />
                    </div>
                    <div className="kt-notification__item-details">
                      <div style={{ fontWeight: 600, fontSize: "12px" }}>
                        <FormattedMessage
                          id="TOPBAR.DROPDOWN.LINK.PROFILE"
                          defaultMessage="My Profile"
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "rgba(156, 163, 175)",
                          marginTop: "4px",
                        }}
                      >
                        <FormattedMessage
                          id="TOPBAR.DROPDOWN.LINK.PROFILETEXT"
                          defaultMessage="Account settings and more"
                        />
                      </div>
                    </div>
                  </Link>
                  <Link
                    to="/my-courses"
                    className={clsx(
                      "kt-notification__item",
                      classes.sideBarPadding
                    )}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div
                      className="kt-notification__item-icon"
                      style={{
                        backgroundColor: "#f3f6f9",
                        borderRadius: 5,
                        padding: "6px 8px",
                        marginRight: 10,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FiCodesandbox color="#5867dd" />
                    </div>
                    <div className="kt-notification__item-details">
                      <div style={{ fontWeight: 600, fontSize: "12px" }}>
                        <FormattedMessage
                          id="TOPBAR.DROPDOWN.LINK.CREATOR"
                          defaultMessage="Creators Space"
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "rgba(156, 163, 175)",
                          marginTop: "4px",
                        }}
                      >
                        <FormattedMessage
                          id="TOPBAR.DROPDOWN.LINK.CREATORTEXT"
                          defaultMessage="Create and Manage your Courses"
                        />
                      </div>
                    </div>
                  </Link>
                  <Link
                    to="/guidelines"
                    className={clsx(
                      "kt-notification__item",
                      classes.sideBarPadding
                    )}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div
                      className="kt-notification__item-icon"
                      style={{
                        backgroundColor: "#f3f6f9",
                        borderRadius: 5,
                        padding: "6px 8px",
                        marginRight: 10,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FiAlignCenter color="#5867dd" />
                    </div>
                    <div className="kt-notification__item-details">
                      <div style={{ fontWeight: 600, fontSize: "12px" }}>
                        <FormattedMessage
                          id="TOPBAR.DROPDOWN.LINK.GUIDELINES"
                          defaultMessage="Guidelines"
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "rgba(156, 163, 175)",
                          marginTop: "4px",
                        }}
                      >
                        <FormattedMessage
                          id="TOPBAR.DROPDOWN.LINK.GUIDELINESTEXT"
                          defaultMessage="Teaching Guidelines"
                        />
                      </div>
                    </div>
                  </Link>
                  {userTutor && (
                    <Link
                      to="/mentoring"
                      className={clsx(
                        "kt-notification__item",
                        classes.sideBarPadding
                      )}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <div
                        className="kt-notification__item-icon"
                        style={{
                          backgroundColor: "#f3f6f9",
                          borderRadius: 3,
                          padding: "6px 8px",
                          marginRight: 10,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <FiUsers color="#5867dd" />
                      </div>
                      <div className="kt-notification__item-details">
                        <div style={{ fontWeight: 600, fontSize: "12px" }}>
                          <FormattedMessage
                            id="TOPBAR.DROPDOWN.LINK.STUDENT"
                            defaultMessage="Mentoring"
                          />
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "rgba(156, 163, 175)",
                            marginTop: "4px",
                          }}
                        >
                          <FormattedMessage
                            id="TOPBAR.DROPDOWN.LINK.STUDENTTEXT"
                            defaultMessage="Students and more"
                          />
                        </div>
                      </div>
                    </Link>
                  )}
                  {/*
                  {isAdmin && (
                    <Link
                      to="/manage-templates"
                      className={clsx(
                        "kt-notification__item",
                        classes.sideBarPadding
                      )}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <div
                        className="kt-notification__item-icon"
                        style={{
                          backgroundColor: "#f3f6f9",
                          borderRadius: 3,
                          padding: "6px 8px",
                          marginRight: 10,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <FiLayout color="#5867dd" />
                      </div>
                      <div className="kt-notification__item-details">
                        <div style={{ fontWeight: 600, fontSize: "12px" }}>
                          <FormattedMessage
                            id="TOPBAR.DROPDOWN.LINK.TEMPLATES"
                            defaultMessage="Manage Templates"
                          />
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "rgba(156, 163, 175)",
                            marginTop: "4px",
                          }}
                        >
                          <FormattedMessage
                            id="TOPBAR.DROPDOWN.LINK.TEMPLATESTEXT"
                            defaultMessage="Create and edit Templates"
                          />
                        </div>
                      </div>
                    </Link>
                  )}
                  */}
                  <Link
                    to="/terms"
                    className={clsx(
                      "kt-notification__item",
                      classes.sideBarPadding
                    )}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div
                      className="kt-notification__item-icon"
                      style={{
                        backgroundColor: "#f3f6f9",
                        borderRadius: 5,
                        padding: "6px 8px",
                        marginRight: 10,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FiLayers color="#5867dd" />
                    </div>
                    <div className="kt-notification__item-details">
                      <div style={{ fontWeight: 600, fontSize: "12px" }}>
                        <FormattedMessage
                          id="TOPBAR.DROPDOWN.LINK.TERMS"
                          defaultMessage="Terms and Conditions"
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "rgba(156, 163, 175)",
                          marginTop: "4px",
                        }}
                      >
                        <FormattedMessage
                          id="TOPBAR.DROPDOWN.LINK.TERMSTEXT"
                          defaultMessage="Our Policies"
                        />
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className={classes.sideBarPadding}>
                <Divider className={classes.sideBarPadding} light />
              </div>
              <div
                style={{ marginBottom: 15, marginTop: 25 }}
                className={classes.sideBarPadding}
              >
                <Typography
                  variant="h6"
                  style={{ fontWeight: 500, color: "#3f4254" }}
                >
                  Our Platforms
                </Typography>

                <div style={{ display: "flex", marginTop: 15, alignItems: "center" }}>
                  {/* <a
                    href="https://block-codes.com/"
                    target="_blank"
                    className="platformIcon"
                    rel="noreferrer"
                  >
                    <OverlayTrigger
                      overlay={
                        <Tooltip style={{ zIndex: 20000 }}>Block Codes</Tooltip>
                      }
                    >
                      <img
                        style={{
                          width: 30,
                          height: "auto",
                          marginRight: 22,
                          marginLeft: 10,
                        }}
                        src={toAbsoluteUrl("/media/platforms/blockcodes.png")}
                      />
                    </OverlayTrigger>
                  </a>
                  <a
                    href="https://apiandme.com/"
                    target="_blank"
                    className="platformIcon"
                    rel="noreferrer"
                  >
                    <OverlayTrigger
                      overlay={
                        <Tooltip style={{ zIndex: 20000 }}>Api And Me</Tooltip>
                      }
                    >
                      <img
                        style={{ width: 30, height: "auto", marginRight: 22 }}
                        src={toAbsoluteUrl("/media/platforms/apiandme.png")}
                      />
                    </OverlayTrigger>
                  </a>
                  <a
                    href="https://raspora.com/"
                    target="_blank"
                    className="platformIcon"
                    rel="noreferrer"
                  >
                    <OverlayTrigger
                      overlay={
                        <Tooltip style={{ zIndex: 20000 }}>Raspora</Tooltip>
                      }
                    >
                      <img
                        style={{ width: 40, height: "auto", marginRight: 22 }}
                        src={toAbsoluteUrl("/media/platforms/raspora.png")}
                      />
                    </OverlayTrigger>
                  </a> */}
                  <a
                    href="https://relysia.com/"
                    target="_blank"
                    className="platformIcon"
                    rel="noreferrer"
                  >
                    <OverlayTrigger
                      overlay={
                        <Tooltip style={{ zIndex: 20000 }}>Relysia</Tooltip>
                      }
                    >
                      <img
                        style={{
                          width: 30, height: "auto", marginRight: 22,
                          marginLeft: 10,
                        }}
                        src={toAbsoluteUrl("/media/platforms/relysia.svg")}
                      />
                    </OverlayTrigger>
                  </a>
                  <a
                    href="https://satolearn.com/"
                    target="_blank"
                    className="platformIcon"
                    rel="noreferrer"
                  >
                    <OverlayTrigger
                      overlay={
                        <Tooltip style={{ zIndex: 20000 }}>SatoLearn</Tooltip>
                      }
                    >
                      <img
                        style={{ width: 30, height: "auto" }}
                        src={toAbsoluteUrl("/media/platforms/sato.png")}
                      />
                    </OverlayTrigger>
                  </a>
                </div>
              </div>
            </PerfectScrollbar>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

const mapStateToProps = ({
  auth: { user, updateProfilePic, profilePicUrl, updateTutorStatus },
}) => ({
  user,
  updateProfilePic,
  profilePicUrl,
  updateTutorStatus,
});

export default withStyles(styles)(
  connect(mapStateToProps, { updateProfilePicFunc })(UserProfile)
);
